module.exports = __webpack_public_path__ + "static/media/left-purple.bb265948.svg";